import {AnnotationsReaderBase} from './AnnotationsReaderBase';
import {AnnotationsReader} from './AnnotationsReader';
import {AnnotationsReaderIE} from './AnnotationsReaderIE';
import {createHelper} from './annotations-reader-helper';

export const createAnnotationsReader = (annotationsServiceLocator) => {
  // Need a service locator to export annotations.
  if (!annotationsServiceLocator) {
    return new AnnotationsReaderBase();
  }

  const helper = createHelper(annotationsServiceLocator);

  const canvas = document.createElement('canvas');
  // Test if browser does not use non-standards msToBlob, which throws a security error exporting svg data from canvas
  if (!!canvas.toBlob && !canvas.msToBlob) {
    return new AnnotationsReader(helper);
    // Test if browser uses non-standards msToBlob and confirm the canvg library is loaded in.
  } else if (!!canvas.msToBlob && window.CanvasRenderingContext2D && window.CanvasRenderingContext2D.prototype.drawSvg) {
    return new AnnotationsReaderIE(helper);
  }

  return new AnnotationsReaderBase();
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/readers/annotations-reader-factory.js